import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import * as Lucide from 'lucide-react'; // Import all icons for flexibility
import { useToast } from '../components/Toast';

function Login() {
  const toast = useToast();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const navigate = useNavigate();
  const { login, isAuthenticated } = useContext(AuthContext);

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/home');
    }
  }, [isAuthenticated, navigate]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError(''); // Clear error when user types
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await login(formData);
      console.log('Login successful:', response);
      navigate('/home');
    } catch (error) {
      console.error('Login failed:', error);
      toast.error(error.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page-container">
      <div className="auth-page-overlay">
        <div className="auth-card">
          <div className="text-center mb-4">
            <div className="btn-icon" style={{ width: '80px', height: '80px', margin: '0 auto', background: 'var(--primary-soft)', color: 'var(--primary)' }}>
              <Lucide.Milk size={40} />
            </div>
          </div>
        
        <h2 className="auth-title">Welcome Back</h2>
        <p className="auth-subtitle">Sign in to manage your dairy farm</p>
        
        {error && (
          <div className="alert alert-error">
            <Lucide.AlertCircle size={18} />
            <span>{error}</span>
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username" className="form-label">Username</label>
            <div style={{ position: 'relative' }}>
              <input 
                type="text" 
                name="username" 
                id="username" 
                className="form-input"
                value={formData.username}
                onChange={handleChange}
                required
                disabled={loading}
                autoComplete="username"
                placeholder="Enter your username"
                style={{ paddingLeft: '2.5rem' }}
              />
              <Lucide.User size={18} style={{ position: 'absolute', left: '0.75rem', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-tertiary)' }} />
            </div>
          </div>
          
          <div className="form-group">
            <label htmlFor="password" className="form-label">Password</label>
            <div style={{ position: 'relative' }}>
              <input 
                type="password" 
                name="password" 
                id="password" 
                className="form-input"
                value={formData.password}
                onChange={handleChange}
                required
                disabled={loading}
                autoComplete="current-password"
                placeholder="Enter your password"
                style={{ paddingLeft: '2.5rem' }}
              />
              <Lucide.Lock size={18} style={{ position: 'absolute', left: '0.75rem', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-tertiary)' }} />
            </div>
          </div>
          
          <button 
            type="submit" 
            className="btn btn-primary w-full" 
            disabled={loading}
            style={{ padding: '0.875rem', fontSize: '1rem', marginTop: '1rem' }}
          >
            {loading ? (
              <>
                <div className="spinner" style={{ width: '20px', height: '20px', borderWidth: '2px', marginRight: '0.5rem', marginBottom: 0 }}></div>
                Signing in...
              </>
            ) : (
              <>
                Sign In
                <Lucide.ArrowRight size={18} style={{ marginLeft: '0.5rem' }} />
              </>
            )}
          </button>
          
          <div className="auth-footer">
            <p>Don't have an account? Contact your administrator.</p>
            
          </div>
        </form>
      </div>
      </div>
    </div>
  );
}

export default Login;